// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__33MHh","requiredAsterisk":"Info_requiredAsterisk__2G-Nr"};